module.exports = __webpack_public_path__ + "static/home-bulb-ae191429b793c687b31e52426d4359cb.svg";